import { type ThemeOptions } from '@mui/material';

export function createCardStyles() {
  return {
    MuiCard: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: `${theme.shape.borderRadiusMd}px`,
          '&:has( .Mui-focusVisible.MuiCardActionArea-root)': {
            borderRadius: `${theme.ui.focus.borderRadius}`,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
